import React from 'react';
import propTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import Auth from '../../routes/auth';

function ProtectedRoute({ component, path }) {
  const isLoggedIns = localStorage.getItem('Multiverse-Expire');
  return isLoggedIns ? <Route component={component} path={path} /> : <Redirect to="/" component={Auth} />;
}

ProtectedRoute.propTypes = {
  component: propTypes.object.isRequired,
  path: propTypes.string.isRequired,
};

export default ProtectedRoute;
